<script setup lang="ts">
  import { useUi } from '@/composition/use-ui';
  import { useOrdersStore } from '@/stores/orders.store';
  import { computed, ref } from 'vue';
  import RestaurantPosNewOrdersItem from './RestaurantPosNewOrdersItem.vue';

  const ordersStore = useOrdersStore();
  const ui = useUi();
  const isOpen = ref(false);
</script>

<template>
  <div class="new-orders-dropdown">
    <div
      v-if="ordersStore.newOrders?.length && !isOpen"
      class="new-indicator"
    ></div>
    <v-menu v-model="isOpen" bottom :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="new-orders-dropdown__btn"
          fab
          small
          depressed
          :color="!ordersStore.newOrders?.length ? 'grey' : 'primary'"
          :dark="!ordersStore.newOrders?.length"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-cart-check</v-icon>
        </v-btn>
      </template>
      <v-list class="new-order-list">
        <template v-if="!ordersStore.newOrders?.length">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>No hay pedidos nuevos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item
            v-for="order in ordersStore.newOrders"
            :key="order.id"
            class="new-order-item"
          >
            <v-list-item-content>
              <RestaurantPosNewOrdersItem :order="order" />
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped lang="scss">
  .new-orders-dropdown {
    @apply tw-relative;

    .new-indicator {
      @apply tw-absolute tw-w-full tw-h-full tw-bg-orange-500 tw-rounded-full tw-left-0 tw-bottom-0 tw-right-0 tw-top-0 tw-animate-ping;
      z-index: 5;
    }

    .new-orders-dropdown__btn {
      z-index: 6;
    }
  }

  .new-order-list {
    @apply tw-divide-y tw-divide-gray-200 tw-divide-dashed tw-overflow-y-auto;
    max-height: 80vh;
    max-height: 80dvh;
    min-width: 340px;

    ::v-deep(.v-list-item) {
    }
  }
</style>
